// extracted by css-extract-rspack-plugin
export default {"pillRoot":"pillRoot-FZDbYC","dragHandleReveal":"dragHandleReveal-yAJfMi","removeButton":"removeButton-hO_ZU7","pillLabel":"pillLabel-bYUVSy","dragging":"dragging-yLQZfS"};